import { render, staticRenderFns } from "./FooldalDesktopLayout.vue?vue&type=template&id=1f14c580&"
import script from "./FooldalDesktopLayout.vue?vue&type=script&lang=js&"
export * from "./FooldalDesktopLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports